import gql from 'graphql-tag';

export const GET_LITE_PLANS = gql`
  query getLitePlans($accountId: Int!) {
    account(id: $accountId) {
      id
      customPlans {
        id
        name
      }
    }
  }
`;

export const getLitePlansMock = {
  account: {
    id: 2,
    customPlans: [
      { id: 1, name: 'first' },
      { id: 2, name: null },
    ],
  },
};
